<mat-card appearance="outlined" data-tfa="bibliotheque-component_card" id="bibliotheque" class="mat-elevation-z3">
    <mat-card-header>
        <mat-card-title>
            @if (!parentPourAjoutEnfant()) {
            <h1 id="bibliotheque-title">Bibliothèque</h1>
            } @else {
            <h1>Ajouter un enfant sous {{ parentPourAjoutEnfant()?.libelle }}</h1>
            }
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <form id="bibliotheque-om-form" data-tfa="bibliotheque-om-form" [formGroup]="form" (keydown.enter)="$event.preventDefault()">
            <mat-form-field id="texte-form-field">
                <mat-label>Rechercher un objet</mat-label>
                <input data-tfa="rechercher-objet-input" matInput type="text" formControlName="texte" (keydown.enter)="rechercher()" />
                @if (form.controls.texte.value) {
                <button
                    matSuffix
                    mat-icon-button
                    aria-label="Vider la saisie"
                    (click)="form.controls.texte.setValue(null)"
                    data-tfa="clear-input-code_button"
                >
                    <mat-icon data-tfa="icon-fermer">close</mat-icon>
                </button>
                }
            </mat-form-field>
            <app-select-type-objet-maquette
                [formFieldStyles]="{ marginTop: '18px' }"
                [control]="form.controls.typeObjetMaquette"
            ></app-select-type-objet-maquette>
            @if (form.controls.typeObjetFormation.enabled) {
            <app-select-nomenclature
                formControlName="typeObjetFormation"
                label="Type d'objet de formation"
                [nomenclature]="NomenclatureType.TypeObjetFormation"
                [isParametrage]="true"
                [formFieldStyles]="{ marginTop: '18px' }"
            >
            </app-select-nomenclature>
            }
            <span style="width: 100%;"></span>
            <mat-checkbox
                class="recherche-checkbox"
                id="bibliotheque-om-form_mutualise-checkbox"
                data-tfa="mutualise"
                formControlName="mutualise"
                >Mutualisé</mat-checkbox
            >
            <mat-checkbox
                class="recherche-checkbox"
                data-tfa="orphelin-checkbox"
                matTooltip="Sans aucun objet parent"
                matTooltipPosition="above"
                formControlName="racine"
            >
                Orphelin
            </mat-checkbox>
            <button
                data-tfa="bouton-rechercher-objet"
                id="bouton-rechercher-objet"
                mat-mini-fab
                color="accent"
                matTooltip="Rechercher"
                (click)="rechercher()"
            >
                <mat-icon data-tfa="icon-search">search</mat-icon>
            </button>
        </form>
        <div
            cdkDropList
            id="drag-bibliotheque"
            [cdkDropListDisabled]="DNDDisabled()"
            [cdkDropListConnectedTo]="['treeview_virtual_scroll_container']"
            [appEnableIfAutorise]="ODF_AJOUTER_ENFANT"
        >
            <table
                id="recherche_objets_maquette-table"
                data-tfa="recherche_objets_maquette-table"
                mat-table
                [dataSource]="dataSource"
                class="expanded-table table-container"
                tabindex="0"
                aria-labelledby="bibliotheque-title"
            >
                <!-- CODE -->
                <ng-container matColumnDef="codeDND" role="row">
                    <th
                        tabindex="0"
                        mat-header-cell
                        *matHeaderCellDef
                        scope="col"
                        disableClear
                        role="columnheader"
                        data-tfa="header-cell_CodeDND"
                    >
                        Code
                    </th>
                    <td tabindex="0" mat-cell *matCellDef="let element" role="cell" [attr.data-tfa]="'cell-codeDND-' + element.code">
                        <mat-card
                            class="of-card"
                            [attr.data-tfa]="'drop-element_' + element.code"
                            cdkDrag
                            [cdkDragData]="dropData(element)"
                            [cdkDragDisabled]="DNDDisabled()"
                        >
                            <mat-card-content
                                >{{ element.code }}@if (!DNDDisabled()) {
                                <mat-icon data-tfa="icone-DND" class="icone-DND material-symbols-outlined">drag_pan</mat-icon>
                                }</mat-card-content
                            >
                            <mat-card data-tfa="drag-preview" *cdkDragPreview>{{ element.code }}</mat-card>
                        </mat-card>
                    </td>
                </ng-container>

                <!-- CODE SANS DND -->
                <ng-container matColumnDef="code" role="row">
                    <th
                        tabindex="0"
                        mat-header-cell
                        *matHeaderCellDef
                        scope="col"
                        disableClear
                        role="columnheader"
                        data-tfa="header-cell_Code"
                    >
                        Code
                    </th>
                    <td tabindex="0" mat-cell *matCellDef="let element" role="cell" [attr.data-tfa]="'cell-code-' + element.code">
                        {{ element.code }}
                    </td>
                </ng-container>

                <!-- LIBELLE -->
                <ng-container matColumnDef="libelle" role="row">
                    <th
                        tabindex="0"
                        mat-header-cell
                        *matHeaderCellDef
                        scope="col"
                        disableClear
                        role="columnheader"
                        data-tfa="header-cell_libelle"
                    >
                        libelle
                    </th>
                    <td tabindex="0" mat-cell *matCellDef="let element" role="cell" [attr.data-tfa]="'cell-libelle-' + element.code">
                        {{ element.libelle }}
                    </td>
                </ng-container>

                <!-- BOUTON OUVRIR -->
                <ng-container matColumnDef="actions" role="row">
                    <th
                        tabindex="0"
                        mat-header-cell
                        *matHeaderCellDef
                        scope="col"
                        disableClear
                        role="columnheader"
                        data-tfa="header-cell_actions"
                    >
                        Ouvrir
                    </th>
                    <td tabindex="0" mat-cell *matCellDef="let element" role="cell" [attr.data-tfa]="'cell-actions-' + element.code">
                        <!-- <mat-card class="of-card" data-tfa cdkDrag [cdkDragData]="dropData(element)"> -->
                        <button
                            [attr.data-tfa]="'bouton-ouvrir_' + element.code"
                            mat-mini-fab
                            *appShowIfAutorise="ODF_LIRE_STRUCTURE_MAQUETTE"
                            [routerLink]="[objetMaquetteOuvertId ? '../' : './', element.id]"
                        >
                            <mat-icon [attr.data-tfa]="'bouton-ouvrir-icon_' + element.code">open_in_browser</mat-icon>
                        </button>
                        <!-- </mat-card> -->
                    </td>
                </ng-container>

                <!-- BOUTON AJOUTER -->
                <ng-container matColumnDef="ajouter" role="row">
                    <th
                        tabindex="0"
                        mat-header-cell
                        *matHeaderCellDef
                        scope="col"
                        disableClear
                        role="columnheader"
                        data-tfa="header-cell_ajouter"
                    >
                        Ajouter
                    </th>
                    <td tabindex="0" mat-cell *matCellDef="let element" role="cell" [attr.data-tfa]="'cell-ajouter-' + element.code">
                        @if (!estEnfantDuparentPourAjout(element)) {
                        <button
                            [attr.data-tfa]="'bouton-ajouter_' + element.code"
                            [matTooltip]="'Ajouter ' + element.code + ' sous ' + parentPourAjoutEnfant()?.code"
                            mat-mini-fab
                            (click)="ajouterEnfant(element)"
                        >
                            <mat-icon [attr.data-tfa]="'bouton-ajouter-icon_' + element.code">add_box</mat-icon>
                        </button>
                        } @else {
                        <mat-icon
                            [matTooltip]="'Cet objet est déjà un enfant de ' + parentPourAjoutEnfant()?.code"
                            [attr.data-tfa]="element.code + '_est-deja-enfant'"
                            >check</mat-icon
                        >
                        }
                    </td>
                </ng-container>

                <ng-container matColumnDef="paginator">
                    <td tabindex="0" mat-footer-cell *matFooterCellDef [attr.colspan]="'100%'" data-tfa="footer-row">
                        <app-paginator [dataSource]="dataSource"></app-paginator>
                    </td>
                </ng-container>

                <tr
                    mat-row
                    *matRowDef="let element; let index = dataIndex; columns: parentPourAjoutEnfant() ? columnsModeAjoutEnfant : columns"
                    [class.selected]="null"
                    [ngClass]="{ 'grey-row': index % 2 !== 0 }"
                    data-tfa="normal-row"
                ></tr>
                <!-- rows -->
                <tr mat-header-row *matHeaderRowDef="parentPourAjoutEnfant() ? columnsModeAjoutEnfant : columns" data-tfa="header-row"></tr>
                <tr mat-footer-row *matFooterRowDef="['paginator']" data-tfa="paginator-row"></tr>
            </table>
        </div>
    </mat-card-content>
</mat-card>
